/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRouteUpdateMutation($routeId: ID!, $type: CUSTOMER_TYPE, $displayName: String, $customerAccountId: ID) {
  LBRRouteUpdate(routeId: $routeId, type: $type, displayName: $displayName, customerAccountId: $customerAccountId) {
    message
    status
  }
}
`
